export const environment = {
  production: false,
  ASSETS_BASE_PATH: '../assets/',
  api: 'https://hazelgro-dev.mobilesoftapps.it/api',
}